import { IsNotEmpty, IsArray, IsString } from 'class-validator';

export class DashboardEnabledWidgetsDTO {

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    widgets: Array<string>;

}
